import { Grid, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { SectionHeader } from '../SectionHeader';
import { EditNeurologicalExamination } from './EditNeurologicalExamination';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from 'react-redux';
import { MissingDetails } from '../MissingDetails';
import { NihssExamination } from './NihssExamination';
import { LegacyExamination } from './LegacyExamination';
import { EditNihssExamination } from './EditNihssExamination';
import axios from '../../../util/Axios';

export function NeurologicalExamination({ test }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const hasNeurologicalExamination = !!test.neurologicalExamination;
  const [neurologicalExamination, setNeurologicalExamination] = useState(test.neurologicalExamination || {});
  const [nihssExamination, setNihssExamination] = useState(test.nihssExamination || {});
  const [nihssItemScores, setNihssItemScores] = useState(test.nihssItemScores || null);
  const [editMode, setEditMode] = useState(false);
  const isAdmin = useSelector((state) => state.GlobalReducer.loggedUser?.adminRole === 'ADMIN');

  useEffect(() => {
    setNeurologicalExamination(test.neurologicalExamination || {});
    setNihssExamination(test.nihssExamination || {});
    setNihssItemScores(test.nihssItemScores || null);
  }, [test]);

  const saveHandler = (val) => {
    setNeurologicalExamination(val);
    setEditMode(false);
  };

  const saveNihssHandler = async (val) => {
    setNihssExamination(val);
    try {
      const resp = await axios(`/strokeTests/${test.uuid}/details`);
      setNeurologicalExamination(resp.data.neurologicalExamination || {});
      setNihssExamination(resp.data.nihssExamination || val || {});
      setNihssItemScores(resp.data.nihssItemScores || null);
    } catch (e) {
      console.error('Failed to refresh NIHSS data after save', e);
      setNihssItemScores(null);
    }
    setEditMode(false);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const showBooleanValue = (value) => {
    if (value === null) return 'N/A';

    return value ? 'Yes' : 'No';
  };

  return (
    <>
      {!editMode ? (
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12}>
            <Stack direction="row">
              <SectionHeader name="Neurological Examination" />
              {isAdmin ? (
                <IconButton
                  onClick={() => {
                    setEditMode(true);
                  }}
                >
                  {hasNeurologicalExamination ? <EditIcon /> : <AddIcon />}
                </IconButton>
              ) : (
                ''
              )}
            </Stack>
          </Grid>
          {hasNeurologicalExamination ? (
            <>
              <Grid item xs={12}>
                <Tabs value={selectedTab} onChange={handleTabChange}>
                  <Tab label="Basic" />
                  <Tab label="NIHSS" />
                </Tabs>
              </Grid>
              {selectedTab === 0 && <LegacyExamination neurologicalExamination={neurologicalExamination} />}
              {selectedTab === 1 && <NihssExamination nihss={nihssExamination} nihssItemScores={nihssItemScores} />}

              <Grid item xs={4}>
                <Typography>TIA</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography sx={{ textAlign: 'right' }}>{showBooleanValue(neurologicalExamination.tia)}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography>NIHSS</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography sx={{ textAlign: 'right' }}>{neurologicalExamination.nihss ?? 'N/A'}</Typography>
              </Grid>
            </>
          ) : (
            <MissingDetails />
          )}
        </Grid>
      ) : selectedTab === 0 ? (
        <EditNeurologicalExamination testId={test.uuid} neurologicalExamination={neurologicalExamination} onCancel={() => setEditMode(false)} onSaved={saveHandler} />
      ) : (
        <EditNihssExamination nihss={nihssExamination} testId={test.uuid} onCancel={() => setEditMode(false)} onSaved={saveNihssHandler} />
      )}
    </>
  );
}
